/**
 * PaymentAd Route - React Router v7
 *
 * Route: /payment-ad
 * Auth-required page that renders EmptyCase after fetching product price by adId.
 */
/* eslint-disable @typescript-eslint/restrict-template-expressions, @typescript-eslint/no-throw-literal, @typescript-eslint/strict-boolean-expressions, @typescript-eslint/prefer-nullish-coalescing, no-console */
import type {LoaderFunctionArgs} from 'react-router-dom'
import {useLoaderData, useLocation} from 'react-router-dom'

import Context from '@s-ui/react-context'

import PaymentAdComponent from './index.js'
// HOC wrapping that used to live in `./index.js`. Moved here so `./index.js`
// exports the raw component and receives Fast Refresh in dev.
const PaymentAd = Context.wrapper(PaymentAdComponent)

/*
 * We call getInitialProps directly here to avoid re-implementing the SEO + pageName lookup;
 * the source function is defined inline on the component in PaymentAd/index.js.
 * We import the component to access the static.
 */
export async function loader({context, request}: LoaderFunctionArgs) {
  const url = new URL(request.url)
  const pathname = url.pathname.endsWith('/') ? url.pathname : `${url.pathname}/`

  const routeInfo = {
    location: {
      pathname,
      search: url.search
    }
  }

  try {
    // PaymentAd.getInitialProps is a static method on the component
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const initialProps = await (PaymentAd as any).getInitialProps({routeInfo, context})
    return {...initialProps, __RR7__: true}
  } catch (error: unknown) {
    console.error('[RR7] PaymentAd loader error:', error)
    throw error
  }
}

export function Component() {
  const data = useLoaderData()
  const location = useLocation()
  // PaymentAd expects `location` (react-router) and `router` (legacy) — pass what it needs.
  return <PaymentAd {...data} location={location} router={{location}} />
}

Component.displayName = 'PaymentAdRoute'
